export class BankProfile {
    bankAcctId: String= "";
	ssn: String= "";
	dcsAccountNumber: String= "";
	bankName: String= "";
	acctType: CharacterData;
	accountType:CharacterData;
	acctDescription: String= "";
	acctNum: string="";
	routingNum: string="";
	email: String="";
	emailConfirm: String="";
	validateForDuplicate: boolean=false;
	saveProfile: boolean=true;
	customerName: String="";
	isCommercial: boolean=false;
    ACCT_CATEGORY_PERSONAL = 'P';
	ACCT_CATEGORY_BUSINESS = 'B';
	bankAcctCategory!: string;
	bankAcctCategoryDesc: String="";
	shortAcctNum: String="";
	nameOnBankAcct: String="";
	csrfPreventionToken: String="";	
	autoPayBankProfile: boolean= false;
	autopayBankProfileId: String="";
	reAuthCode: String="";
	custLoginId: String="";
	thirdPartyNum: String="";	
	bankAccValStatus: String="";
	bankAccValRefId: String="";
	bankAccValTmstmp: String="";
	bankAccValRtnCode: String="";
    vendorServiceCall: String="";
	dtpay_customer_id: String="";
	dtpay_payment_method_token: String="";
	maskedAccountNumber: String="";

    // private bankAccountId!: BigInteger;
    // private ssn!: String;
    // private dcsAccountNumber!: String;
    // private email!: String;        
    // private bankName!: String;
    // private bankAccountType!: String;
    // private bankAccountNumber!: String;   
    // private bankAcctCategory!: CharacterData;
    // private nameOnBankAcct!: String;
	// private custLoginId!: String;
    // private thirdPartyNum!: String;	
	// private bankAccValStatus!: String;
	// private bankAccValRefId!: String;
	// private bankAccValTmstmp!: String;
	// private bankAccValRtnCode!: String;
    // private vendorServiceCall!: String;


    // private bankABANumber!: String;

    // private prefillBankInfo!: String;
}
